import { undefinedOrTransformToDTOCurried } from '@maia/utils';
import { IAddressEntity } from '../../entitites/common/address.entity';

export class AddressDto {
  readonly guid: string;
  readonly street: string;
  readonly number: number;
  readonly appendix: string | undefined;
  readonly city: string;
  readonly postalCode: string;
  readonly country: string;

  constructor(entity: IAddressEntity) {
    this.guid = entity.guid;
    this.street = entity.street;
    this.number = entity.house_number;
    this.appendix = entity.house_number_appendix ?? undefined;
    this.city = entity.city;
    this.postalCode = entity.postal_code;
    this.country = entity.country;
  }
}

export const undefinedOrAddress = undefinedOrTransformToDTOCurried(
  (entity: IAddressEntity) => new AddressDto(entity),
);

export class AddressPostDto implements Omit<IAddressEntity, 'guid'> {
  readonly street: string;
  readonly house_number: number;
  readonly house_number_appendix: string | null;
  readonly city: string;
  readonly postal_code: string;
  readonly country: string;

  constructor(address: Omit<AddressDto, 'guid'>) {
    this.street = address.street;
    this.house_number = address.number;
    this.house_number_appendix = address.appendix ?? null;
    this.city = address.city;
    this.postal_code = address.postalCode;
    this.country = address.country;
  }
}
